import Text from 'components/_UI/Text'
import DynamicProfileImage from 'components/commons/DynamicProfileImage'
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { UserPlus, UserCheck, MessageCircle, Calendar, Phone } from 'lucide-react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'
import { Row } from 'styled/alignment/Row'
import { formatPhone } from 'helpers/phone'
import { getProducerProfileImage } from 'helpers/profileImage'
import breakpoints from 'theme/breakpoints'
import colors from 'theme/colors'
import fonts from 'theme/fonts'
import paths from 'routes/paths'
import { useAuth } from 'context/auth/Auth'
import LoginModal from 'modules/onboarding/sign-in/LoginModal'
import useFollow from 'hooks/useFollow'

// `profileUrl` leva "Ver eventos" a outro perfil que não o de produtor (ex.: estabelecimento).
export default function ProducerProfileCard({ data, profileUrl }) {
    const navigate = useNavigate();
    const { isAuth, user } = useAuth();
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const { isFollowing, toggleFollow } = useFollow(data?.user_id, data?.is_following);

    const isOwner = isAuth && user?.id === data?.user_id;

    function handleFollow() {
        toggleFollow(() => setIsLoginModalOpen(true));
    }

    return (
        <Container>
            <ProfileRow>
                <Column width='auto'>
                    <DynamicProfileImage
                        img={getProducerProfileImage(data, 'path')}
                        size={'80px'}
                        word={data?.name}
                    />
                </Column>

                <Column marginLeft='14px'>
                    <Text name='highlight' color={colors.nightDark}>
                        {data?.name}
                    </Text>
                    <Text>{data?.description}</Text>
                    {data?.phone && (
                        <Row marginTop='4px'>
                            <Phone size={'18px'} />
                            <Text marginLeft={'6px'}>{formatPhone(data.phone)}</Text>
                        </Row>
                    )}
                </Column>
            </ProfileRow>

            <ActionsRow>
                {!isOwner && (
                    <ActionButton variant={isFollowing ? 'outline' : undefined} onClick={handleFollow}>
                        {isFollowing ? (
                            <UserCheck size={16} color={colors.night} />
                        ) : (
                            <UserPlus size={16} color={colors.occasionalPurple} />
                        )}
                        <ActionLabel>{isFollowing ? 'Seguindo' : 'Seguir'}</ActionLabel>
                    </ActionButton>
                )}

                {/*<ActionButton variant='outline'>*/}
                {/*    <MessageCircle size={16} color={colors.night} />*/}
                {/*    <ActionLabel>Fale com o produtor</ActionLabel>*/}
                {/*</ActionButton>*/}

                <ActionButton variant='outline' onClick={() => window.open(profileUrl || `${paths.producer.page}/${data?.slug}`, '_blank')}>
                    <Calendar size={16} color={colors.night} />
                    <ActionLabel>Ver eventos</ActionLabel>
                </ActionButton>
            </ActionsRow>

            <LoginModal
                isOpen={isLoginModalOpen}
                onClose={() => setIsLoginModalOpen(false)}
            />
        </Container>
    )
}

const Container = styled(Column)`
    gap: 16px;
`;

const ProfileRow = styled(Row)`
    align-items: center;
`;

const ActionsRow = styled(Row)`
    gap: 8px;
    flex-wrap: wrap;
`;

const ActionButton = styled.button`
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    border-radius: 20px;
    cursor: pointer;
    transition: all 0.2s ease;
    font-family: inherit;
    border: 1.5px solid ${({ variant }) => variant === 'outline' ? colors.neutralDark : colors.occasionalPurple};
    background: ${({ variant }) => variant === 'outline' ? colors.neutralLight : colors.occasionalPurple + '0A'};
    color: ${({ variant }) => variant === 'outline' ? colors.night : colors.occasionalPurple};

    &:hover {
        border-color: ${colors.occasionalPurple};
        background: ${colors.occasionalPurple}12;
    }
`;

const ActionLabel = styled.span`
    font-size: ${fonts.sizes.small};
    font-weight: ${fonts.weight.bold};
    white-space: nowrap;
`;
